import GetUserQuery from './GetUserQuery';
import withUser from './withUser';

export { withUser };

export default GetUserQuery;
